import { ImageKind } from "redmond";
import type { Vehicle } from "@b2bportal/ground-api";
import { BookingCompleteData } from "@capone/common";
import { getVehicleClassLabelFromVehicle } from "../../availability/reducer/utils/getVehicleClassLabel";

export const buildCarBookingData = (booking: {
  groundBookingId: string;
  pickUp: { dateTime: string; location: { name: string } };
  dropOff: { dateTime: string; location: { name: string } };
  vehicle: Vehicle;
}): BookingCompleteData => {
  const description = getVehicleClassLabelFromVehicle(booking.vehicle);
  return {
    // Cars saga uses Redux (not CartFulfillSuccessContext); fulfill API has no earnedRewards field.
    earnedRewards: { value: 0, currency: "Miles" },
    booking: {
      type: "car",
      itineraryId: booking.groundBookingId,
      pickUpDateTime: booking.pickUp.dateTime,
      pickUpLocation: booking.pickUp.location.name,
      dropOffDateTime: booking.dropOff.dateTime,
      dropOffLocation: booking.dropOff.location.name,
      imageUrl:
        booking.vehicle.images?.[ImageKind.Original] ??
        booking.vehicle.images?.[ImageKind.Illustration] ??
        "",
      ...(description != null ? { description } : {}),
    },
  };
};
